import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const PaymentCancel = () => (
  <div className="min-h-screen flex items-center justify-center p-6 bg-dotted">
    <div className="nv-card max-w-lg w-full p-8 text-center" data-testid="payment-cancel-card">
      <div className="w-16 h-16 rounded-full bg-novatus-card-2 border-2 border-novatus flex items-center justify-center mx-auto mb-4">
        <XCircle className="w-8 h-8 text-novatus-text-2" />
      </div>
      <h1 className="font-display font-black text-2xl text-white">Zahlung abgebrochen</h1>
      <p className="text-novatus-text-2 mt-2">
        Es wurde nichts berechnet. Du kannst jederzeit erneut starten — Voice-Minuten
        bekommst du immer dann, wenn du sie brauchst.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 mt-6">
        <Link to="/dashboard" className="btn-green flex-1 h-11 rounded-lg leading-[44px]">
          Zum Dashboard
        </Link>
        <Link to="/training" className="flex-1 h-11 rounded-lg border border-novatus text-novatus-text-2 hover:bg-white/5 inline-flex items-center justify-center">
          Text-Training (kostenlos)
        </Link>
      </div>
    </div>
  </div>
);

export default PaymentCancel;
